import React, { Component } from 'react';
import ReactTable from 'react-table';
import { CSVLink/*, CSVDownload*/ } from "react-csv";
import {
  Row, Col, Input,
  Button,
  Spinner,
  Container,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import Groupings from '../Groupings/Groupings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { faStar as faStarOutline } from '@fortawesome/free-regular-svg-icons'
import CopyString from '../CopyString/CopyString';
import * as utilities from '../../utilities';
import CollapseCard from '../CollapseCard/CollapseCard';
import CompanyContext from '../../auth/CompanyContext';

//Sort method used for react-table
function numberStringSort(a, b) {

  var a_num = 0;
  var b_num = 0;

  if (typeof a === 'string') {
    a_num = parseFloat(a.replace(/[$,]/gi, ''));
    if (isNaN(a_num)) {
      a_num = 0;
    }
  }
  else {
    if (!isNaN(a)) {
      a_num = a;
    }
  }

  if (typeof b === 'string') {
    b_num = parseFloat(b.replace(/[$,]/gi, ''));
    if (isNaN(b_num)) {
      b_num = 0;
    }

  }
  else {
    if (!isNaN(b)) {
      b_num = b;
    }
  }
  return a_num === b_num ? 0 : (a_num > b_num ? 1 : -1);
}

//Column data initialization




const column_groups = [
  {
    accessor: 'AUM Total',
    type: 'currency'
  },
  {
    accessor: 'Total Accounts'
  },
  {
    accessor: 'Discretionary AUM',
    type: 'currency'
  },
  {
    accessor: 'Discretionary Accounts'
  },
  {
    accessor: 'Non-Discretionary AUM',
    type: 'currency'
  },
  {
    accessor: 'Non-Discretionary Accounts'
  },
  {
    accessor: 'HNW AUM',
    type: 'currency'
  },
  {
    accessor: 'HNW Accounts'
  },
  {
    accessor: 'Pension AUM',
    type: 'currency'
  },
  {
    accessor: 'Pension Accounts'
  },
  {
    accessor: 'Individual AUM',
    type: 'currency'
  },
  {
    accessor: 'Individual Accounts'
  },
  {
    accessor: 'Individual, HNW or Pension Accounts'
  },
  {
    accessor: 'Individual, HNW or Pension AUM',
    type: 'currency'
  },
  {
    accessor: 'Discretionary or Non-Discretionary Accounts'
  },
  {
    accessor: 'Discretionary or Non-Discretionary AUM',
    type: 'currency'
  },


];
class AdvancedSearchResults extends Component {
  static contextType = CompanyContext;

  constructor(props) {

    super(props);

    this.reactTable = React.createRef();

    this.columns = [
      {
        Header: <FontAwesomeIcon icon={faStar} />,
        accessor: 'Favorites',
        filterable: false,
        width: 60,
        Cell: row => (parseInt(row.row['Favorites']) > 0) ?
          <FontAwesomeIcon icon={faStar} className="favoriteIcon" onClick={() => this.props.removeFavorite('sec', row.row['SEC#'], this.favoriteCallback)} />
          : <FontAwesomeIcon icon={faStarOutline} className="favoriteIconDisabled" onClick={() => this.props.addFavorite('sec', row.row['SEC#'], this.favoriteCallback)} />
      },
      {
        Header: () => (
          <span>
            <input
              type="checkbox"
              name="selectAllNone"
              checked={this.state.selectAllNone || this.props.selected.length === this.state.items.length}
              onChange={(e) => this.props.changeSelectedAllNone(e, this.state.items)}
              className="text-center"
            />
          </span>
        ),
        id: 'selection',
        accessor: 'SEC#',
        filterable: false,
        sortable: false,
        width: 60,
        Cell: row => <div onClick={() => this.props.changeSelected(row.row['SEC#'])} className="rt-resizable-header-content">
          <input
            type="checkbox"
            id={"group_" + row.row['SEC#']}
            readOnly
            checked={this.props.selected.findIndex(i => i === row.row['SEC#']) > -1}
          /></div>
      },
      {
        Header: 'SEC#',
        accessor: 'SEC#',
        // filterable: false
      },
      {
        Header: 'Primary Business Name',
        accessor: 'Primary Business Name',
        // filterable: false,
        Cell: row => row.row['SEC#'] !== '' ?
          <><Link to={{
            pathname: '/demographics/' + row.row['SEC#'],
            state: {
              currentDate: props.searchOptions.current_date,
              searchState: this.state.searchState
            }/*, id: row.row['SEC#']*/
          }}>{row.original?.['DBA Business Name'] ? <>DBA {row.original['DBA Business Name']}</> : <>{row.value}</>}</Link>
            {row.original?.['DBA Business Name'] ? <span className="searchResultsSmall"> ({row.value})</span> : <></>}
          </> : <>{row.value}</>

      },
      {
        Header: 'Address 1',
        accessor: 'Main Office Street Address 1'
      },
      {
        Header: 'Address 2',
        accessor: 'Main Office Street Address 2'
      },
      {
        Header: 'City',
        accessor: 'Main Office City'
      },
      {
        Header: 'State',
        accessor: 'Main Office State',
        width: 60
      },
      {
        Header: 'ZIP',
        accessor: 'Main Office Postal Code',
        width: 100
      },
      {
        Header: 'Telephone #',
        accessor: 'Main Office Telephone Number',
        width: 150
      },
      {
        Header: 'Fax #',
        accessor: 'Main Office Facsimile Number',
        width: 150
      },
      {
        Header: 'SEC Status Effective Date',
        accessor: 'SEC Status Effective Date',
        Cell: (props) => {
          //props.value will contain your date
          //you can convert your date here
          const custom_date = props.value
          let custom_date_format = custom_date.substr(5, 2) + '/' + custom_date.substr(8, 2) + '/' + custom_date.substr(0, 4)
          return <span>{custom_date_format}</span>
        }
      },
      {
        Header: 'Website',
        accessor: 'Website Address',
        Cell: row => (<a href={row.value} target="_blank" rel="noopener noreferrer">{row.value}</a>)
      },
      {
        Header: 'New',
        accessor: 'New'
      },
      {
        Header: 'Comments Created',
        accessor: 'CommentsCreated',
        Cell: row => {
          if (row.value != null && row.value !== '') {
            const d = new Date(parseInt(row.value));
            return <>{(d.getMonth() + 1) + '/' + d.getDate() + '/' + String(d.getFullYear()).substr(-2)}</>
          } else {
            return <></>
          }
        }
      },
      {
        Header: 'Comments Updated',
        accessor: 'CommentsUpdated',
        Cell: row => {
          if (row.value != null && row.value !== '') {
            const d = new Date(parseInt(row.value));
            return <>{(d.getMonth() + 1) + '/' + d.getDate() + '/' + String(d.getFullYear()).substr(-2)}</>
          } else {
            return <></>
          }
        }
      },
      // {
      //   Header: 'Company Type',
      //   accessor: 'Company Type',
      //   width: 180,
      //   filterMethod: (filter, row) =>
      //     String(row[filter.id] || '').toLowerCase().includes(filter.value.toLowerCase())
      // }
    ]

    // if (this.props.searchOptions?.notes_category > 0 || this.props.searchOptions?.notes_category_list > 0) {
    //   const categoryTitle = this.props.notesCategories
    //     .flatMap(parent => parent.children)
    //     .find(child => child.ID === parseInt(this.props.searchOptions?.notes_category))?.type;
    //   this.columns.push({
    //     Header: categoryTitle,
    //     accessor: 'Demographics',
    //     Cell: row => {
    //       // console.log(row)
    //       if (row.value?.length > 0) {
    //         const foundObject = row.value.find(item => parseInt(item["Type ID"]) === parseInt(this.props.searchOptions.notes_category));
    //         return foundObject?.Comment || ''
    //       } else {
    //         return <></>
    //       }
    //     }
    //   })
    // }

    column_groups.forEach(g => {

      var type = null;
      if (g['type']) {
        type = g['type'];
      }

      var current = {
        Header: g.accessor + (type === 'currency' ? ' $' : ''),
        accessor: g.accessor,
        sortMethod: numberStringSort,
        width: 150
      };

      var previous = {
        Header: g.accessor + (type === 'currency' ? ' $' : '') + ' (previous)',
        accessor: g.accessor + ' (previous)',
        sortMethod: numberStringSort,
        width: 150
      };
      var growth = {
        Header: g.accessor + ' Growth' + (type === 'currency' ? ' $' : ''),
        accessor: g.accessor + ' Growth',
        sortMethod: numberStringSort,
        width: 150
      };

      var growth_percent = {
        Header: g.accessor + ' Growth %',
        accessor: g.accessor + ' Growth %',
        sortMethod: numberStringSort,
        width: 150
      };

      if (type) {
        current.type = type;
        previous.type = type;
        growth.type = type;
      }

      this.columns.push(current, previous, growth, growth_percent);
    });

    // if (this.props.searchOptions.showContacts) {
    //   this.columns.push(
    //     {
    //       Header: 'Contacts',
    //       accessor: 'Contacts',
    //       width: 200,
    //       Cell: (props) => {
    //         const contacts = props.value;
    //         if (contacts && contacts.length > 0) {
    //           return <div style={{ textAlign: 'left' }}>
    //             {contacts.map(contact =>
    //               <div style={{ marginBottom: '10px' }}>
    //                 {contact['Contact Name'] && <div>{contact['Contact Name']}</div>}
    //                 {contact['Title'] && <div>{contact['Title']}</div>}
    //                 {contact['Phone Number'] && <div>{contact['Phone Number']}</div>}
    //                 {contact['Email Address'] && <div style={{ textWrap: 'nowrap' }}><CopyString textToCopy={contact['Email Address']} />&nbsp;<a href={'mailto:' + contact['Email Address']}>{contact['Email Address']}</a></div>}
    //               </div>)}
    //           </div>
    //         } else {
    //           return <></>
    //         }
    //       }
    //     },
    //   )
    // }

    this.state = {
      items: sessionStorage.getItem('advancedSearchResultsItems') ? JSON.parse(sessionStorage.getItem('advancedSearchResultsItems')) : [],
      posts: [],
      'csv_rows': [],
      loading: false,
      'visible_columns': [...this.columns],
      'debug_message': null,
      selectAllNone: false,
      searchState: this.props.searchState
    };

  }

  componentDidMount() {
    if (!sessionStorage.getItem('advancedSearchResultsItems')) {
      this.setState(
        { loading: true },
        () => { this.getItems(); }
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(this.props.searchOptions) !== JSON.stringify(prevProps.searchOptions)) {
      this.setState(
        { loading: true },
        () => { this.getItems(); }
      );
    }
  }

  favoriteCallback = (data) => {
    let items = [...this.state.items];
    items.forEach(result => {
      result['Favorites'] = ("sec" in data && data.sec.findIndex(item => item.Favorite === result['SEC#']) > -1) ? 1 : '';
    })
    this.setState({
      items: items
    })
  }

  getItems() {

    const json_request = JSON.stringify({ ...this.props.searchOptions, auth0: this.props.user });


    fetch('/api/advancedSearch/', {
      method: 'POST',
      body: json_request,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.clientToken,
        'X-Database': this.context.company
      }
    })
      .then(results => results.json())
      .then(results => {
        if (!results.rows) {
          utilities.addToast(results.debug_message?.error?.originalError?.info?.message || 'Search Error', 0, 'danger');
          return this.setState({
            'visible_columns': [],
            loading: false,
            items: [],
            'debug_message': results.debug_message,
            'csv_rows': []
          });
        }
        this.setState((prevState, props) => {

          if (json_request === JSON.stringify({ ...this.props.searchOptions, auth0: this.props.user })) {
            let rows = results.rows;

            // const getAttrValues = (attrs, name) =>
            //   (Array.isArray(attrs) ? attrs : [])
            //     .filter(a => (a?.attribute || '').toLowerCase() === name.toLowerCase())
            //     .map(a => a?.value)
            //     .filter(v => v != null && String(v).trim() !== '');

            // rows = rows.map(r => ({
            //   ...r,
            //   ['Company Type']: getAttrValues(r.Attributes, 'Company Type').join(', ')
            // }));

            let debug_message = results.debug_message;

            const demographicsArray = [...new Set(rows.flatMap(item => (item.Demographics ? item.Demographics : [])).map(demo => `${demo?.['Type']}|${demo?.['Type ID']}`))].sort();
            //debug_message.statement = debug_message.statement.replace(/\\n/g,"\n");

            const visible_columns = [];

            if (rows && rows.length > 0) {
              this.columns.forEach(c => {
                if (c.accessor in rows[0]) {
                  visible_columns.push(c);
                }
              });


              rows.forEach((i) => {
                visible_columns.forEach((c) => {

                  let col_val = i[c.accessor] ? i[c.accessor] : "";
                  if (c.type && c.type === 'currency') {
                    col_val = i[c.accessor] ? '$' + parseFloat(i[c.accessor]).toLocaleString('USD') : "";
                  }

                  if (typeof col_val === "string") {
                    const matches = col_val.match(/^"(.*)"$/);
                    if (matches) {
                      col_val = matches[1];
                    }
                    i[c.accessor] = col_val.replace(/"/g, '""');
                  }
                })
              });
            }

            demographicsArray.forEach(demographic => {
              visible_columns.push({
                Header: demographic.split('|')?.shift() || '',
                accessor: `Demographics|${demographic.split('|')?.shift()}`,
                id: demographic.split('|')?.shift() || '',
                // Cell: row => {
                //   // console.log(row)
                //   if (row.value?.length > 0) {
                //     const foundObject = row.value.find(item => parseInt(item["Type ID"]) === parseInt(demographic.split('|')?.pop()));
                //     return foundObject?.Comment || ''
                //   } else {
                //     return <></>
                //   }
                // },
                filterMethod: (filter, row) => {
                  // Access the demographics array from the row
                  // const demographics = row.value?.Demographics;
                  const locationObj = row._original?.Demographics?.find(item => parseInt(item["Type ID"]) === parseInt(demographic.split('|')?.pop()));
                  if (locationObj) {
                    return locationObj?.Comment.toLowerCase().includes(filter.value.toLowerCase());
                  }
                  return false;
                },
              })
            })

            if (this.props.searchOptions.showContacts) {
              visible_columns.push(
                {
                  Header: 'Contacts',
                  accessor: 'Contacts',
                  width: 200,
                  Cell: (props) => {
                    const contacts = props.value;
                    if (contacts && contacts.length > 0) {
                      return <div style={{ textAlign: 'left' }}>
                        {contacts.map((contact, contactIndex) =>
                          <div key={contactIndex} style={{ marginBottom: '10px' }}>
                            {contact['Contact Name'] && <div>{contact['Contact Name']}</div>}
                            {contact['Title'] && <div>{contact['Title']}</div>}
                            {contact['Phone Number'] && <div>{contact['Phone Number']}</div>}
                            {contact['Email Address'] && <div style={{ textWrap: 'nowrap' }}><CopyString textToCopy={contact['Email Address']} />&nbsp;<a href={'mailto:' + contact['Email Address']}>{contact['Email Address']}</a></div>}
                          </div>)}
                      </div>
                    } else {
                      return <></>
                    }
                  }
                },
              )
            }

            var csv_rows = [];

            if (rows) {
              csv_rows = [
                // Flatten the headers for Contacts into individual columns
                visible_columns
                  .filter(c => c.accessor !== 'Favorites' && typeof (c.Header) === 'string')
                  .flatMap(c => c.Header === 'Contacts'
                    ? ['Contact Name', 'Title', 'Email Address', 'Phone Number']
                    : c.Header),
                ...rows.flatMap(i => {
                  const baseRow = visible_columns.filter(c => c.accessor !== 'Favorites' && typeof (c.Header) === 'string').flatMap(c => {
                    if (c.Header === 'Contacts' && i[c.accessor]) {
                      const contacts = i[c.accessor];
                      if (contacts && contacts.length > 0) {
                        // First contact details
                        const firstContact = contacts[0];
                        return [
                          firstContact['Contact Name'],
                          firstContact['Title'],
                          firstContact['Email Address'],
                          firstContact['Phone Number']
                        ];
                      } else {
                        // If no contacts, return empty fields for contact columns
                        return ['', '', '', ''];
                      }
                    } else {
                      // Non-contact columns
                      return i[c.accessor] ? i[c.accessor] : "";
                    }
                  });

                  // Subsequent contact rows
                  const contactRows = (i.Contacts || []).slice(1).map(contact => [
                    ...visible_columns
                      .filter(c => c.accessor !== 'Favorites' && typeof (c.Header) === 'string' && c.Header !== 'Contacts')
                      .flatMap(c => c.Header === 'Contacts' ? '' : ""),
                    contact['Contact Name'],
                    contact['Title'],
                    contact['Email Address'],
                    contact['Phone Number']
                  ]);

                  return [baseRow, ...contactRows];
                })
              ];
            }

            const maxContacts = rows != null ? Math.max(...[...rows].map(item => {
              if (!("Comments" in item)) return 0;
              return item.Comments.reduce((accumulator, commentGroups) => {
                const cg = commentGroups.filter(comment => comment.commentType === 1 || comment.commentType === 2)
                // console.log(cg);
                return accumulator + ((cg.length > 0) ? 1 : 0)
              }, 0);
            })) : 0;
            for (let i = 0; i < maxContacts; i++) {
              visible_columns.push(
                {
                  Header: 'Contact ' + (i + 1),
                  accessor: 'Comments',
                  Cell: row => {
                    let contactsArr = [];
                    const data = row.value;
                    data.forEach(linkedItem => {
                      let commentObj = { name: '', email: '' };
                      linkedItem.forEach(comment => {
                        if (comment.commentType === 1) commentObj.name = comment.comment;
                        if (comment.commentType === 2) commentObj.email = comment.comment;
                      });
                      if (commentObj.name !== '' || commentObj.email !== '') contactsArr.push(commentObj);
                    })
                    return (<span>{(contactsArr.length > i) ? contactsArr[i].name : ''}</span>);
                  }
                },
                {
                  Header: 'Email ' + (i + 1),
                  accessor: 'Comments',
                  Cell: row => {
                    let contactsArr = [];
                    const data = row.value;
                    data.forEach(linkedItem => {
                      let commentObj = { name: '', email: '' };
                      linkedItem.forEach(comment => {
                        if (comment.commentType === 1) commentObj.name = comment.comment;
                        if (comment.commentType === 2) commentObj.email = comment.comment;
                      });
                      if (commentObj.name !== '' || commentObj.email !== '') contactsArr.push(commentObj);
                    })
                    return (<span>{(contactsArr.length > i) ? contactsArr[i].email : ''}</span>);
                  }
                },
              )
            }

            let return_value = {
              'visible_columns': visible_columns,
              loading: false,
              items: rows,
              'debug_message': debug_message,
              'csv_rows': csv_rows
            };

            const jsonString = JSON.stringify(rows);

            // Create a Blob object and measure the size in bytes
            const blob = new Blob([jsonString], { type: 'application/json' });
            const sizeInBytes = blob.size;
            const sizeInMB = sizeInBytes / (1024 * 1024);
            console.log(`Size in MB: ${sizeInMB.toFixed(2)} MB`);

            if (sizeInMB < 5) {
              sessionStorage.setItem('advancedSearchResultsItems', JSON.stringify(rows));
            }

            return return_value;
          }
          else {
          }
        });
      });
    return;
  }

  render() {
    if (this.state.loading) {
      return (
        <Container>
          <Row>
            <Col md={12} className='text-center'>
              <h1>Searching...</h1>
            </Col>
          </Row>
          <div><Spinner className="p-5 m-5" color="primary" /></div>
          <Button onClick={this.props.onDismissResults}>Cancel Search</Button>
        </Container>
      );
    } else if (this.state.debug_message?.error != null) {
      return (
        <Container>
          <h1>Search Error</h1>
          <Button onClick={this.props.onDismissResults}>Back to Search</Button>
          <CollapseCard title="Query" open={true} >
            <Input
              type="textarea"
              rows={50}
              value={this.state.debug_message?.parsedStatement}
            >
            </Input>
          </CollapseCard>
        </Container>
      )
    } else {
      return (
        <Container fluid={true} className="p-0">

          <Row className='align-items-end'>
            <Col md={2} className='text-left pl-4'>
            </Col>
            <Col md={8} className='text-center'>
              <Row>
                <Col>
                  <h1>Search Results ({this.state.items == null ? '0' : new Intl.NumberFormat().format(this.state.items.length)})</h1>
                </Col>
              </Row>
              <Button className="my-4" onClick={this.props.onDismissResults}>Back to Search</Button>&nbsp;
              <Button className="my-4" onClick={this.props.handleReset}>Reset Search</Button>&nbsp;
              <CSVLink
                filename='Search Results.csv'
                className="btn btn-primary"
                data={this.state.csv_rows.map(row => row.map(col => {
                  return (typeof (col) === 'function') ? null : col
                }))}>Download CSV</CSVLink>&nbsp;
              {("reportState" in this.state.searchState && this.state.searchState.reportState.ID > 0) ?
                <>
                  <Button color="primary" className="my-4" onClick={(e) => this.props.onLaunchSaveSearch(false)}>Update Saved Search</Button>&nbsp;
                  <Button color="primary" className="my-4" onClick={(e) => this.props.onLaunchSaveSearch(true)}>New Saved Search</Button>
                </>
                :
                <Button color="primary" className="my-4" onClick={(e) => this.props.onLaunchSaveSearch(true)}>Save Search</Button>
              }
            </Col>
            <Col md={2} className='text-right pr-4'>
              <Groupings
                {...this.props}
                favoriteCallback={this.favoriteCallback}
              />
            </Col>
          </Row>

          <ReactTable
            data={this.state.items}
            columns={this.state.visible_columns}
            showPaginationTop={true}
            defaultPageSize={(this.props.showAll) ? (this.props.pageSizeOptions.reduce((accumulator, currentValue, currentIndex) => {
              return (
                ((accumulator === 0 && this.state.items.length < currentValue) || (
                  accumulator === 0 && currentIndex === this.props.pageSizeOptions.length - 1)) ? currentValue : accumulator)
            }, 0)) : 100}
            pageSizeOptions={this.props.pageSizeOptions}
            onPageChange={() => window.scrollTo(0, 0)}
            filterable={true}
            ref={this.reactTable}
            onFilteredChange={(filtered, column) => sessionStorage.setItem('advancedSearchResultsFiltered', JSON.stringify(filtered))}
            defaultFiltered={sessionStorage.getItem('advancedSearchResultsFiltered') ? JSON.parse(sessionStorage.getItem('advancedSearchResultsFiltered')) : []}
            onSortedChange={(sorted, column) => sessionStorage.setItem('advancedSearchResultsSorted', JSON.stringify(sorted))}
            defaultSorted={sessionStorage.getItem('advancedSearchResultsSorted') ? JSON.parse(sessionStorage.getItem('advancedSearchResultsSorted')) : []}
            defaultFilterMethod={(filter, row) => {
              return String(row[filter.id])
                .toLowerCase()
                .includes(filter.value.toLowerCase());
            }}
          />
          {/*<div>Results ({this.state.items == null ? '0' : new Intl.NumberFormat().format(this.state.items.length)})</div>
          <div><pre>{JSON.stringify(this.state.debug_message, null, 4).replace(/\\n/g, "\n")}</pre></div>*/}
        </Container>);
    }
  }
}
export default AdvancedSearchResults;